import { render } from "./EditableTextArea.vue?vue&type=template&id=68bec10a"
import script from "./EditableTextArea.vue?vue&type=script&lang=js"
export * from "./EditableTextArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__